const STORAGE_KEY = 'trusted_device_id';

/**
 * Returns a stable device identifier persisted in localStorage.
 * Unlike browser fingerprinting (which can drift daily due to browser updates,
 * extension changes, etc.), this token remains constant until the user
 * explicitly clears their browser storage.
 */
export const getDeviceFingerprint = async (): Promise<string> => {
  let deviceId = localStorage.getItem(STORAGE_KEY);

  if (!deviceId) {
    deviceId = crypto.randomUUID();
    localStorage.setItem(STORAGE_KEY, deviceId);
  }

  return deviceId;
};
